var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main login-form login"},[_c('div',{staticClass:"page-content"},[_c('ShopInfo'),_c('Login',{ref:"login",attrs:{"abody":false,"isModal":false,"isClose":false}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }